import { useHappyHourContext } from "@src/lib/happyHour/HappyHourContext";
import { EHappyHourLocation } from "@src/lib/happyHour/types/HappyHour.interface";

export const useHappyHourMessageByLocation = (
  location?: EHappyHourLocation
) => {
  const { data } = useHappyHourContext();
  const locationMessage = location ? data?.[location] : undefined;
  return !!locationMessage?.message ? locationMessage : undefined;
};
